export default __webpack_public_path__ + "static/media/home.1f28f250.svg";